"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.fields = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _arrowResize = _interopRequireDefault(require("cccisd-icons/arrow-resize3"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _Tab = _interopRequireDefault(require("./Tab"));
var _reorder = _interopRequireDefault(require("../../../../../helpers/reorder.js"));
var _generateNewId = require("../../../../../helpers/generateNewId.js");
var _style = _interopRequireDefault(require("../style.css"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var fields = exports.fields = ['tabs[].id', 'tabs[].label', 'tabs[].tag',
// keeping for backwards compatibility; icons should now be set in wysiwyg
'tabs[].icon', 'tabs[].topFilterBar.showTopFilterBar', 'tabs[].topFilterBar.title', 'tabs[].topFilterBar.tags[]', 'tabs[].filterGroups[].id', 'tabs[].filterGroups[].name', 'tabs[].filterGroups[].icon', 'tabs[].filterGroups[].color', 'tabs[].filterGroups[].collapsible', 'tabs[].filterGroups[].isCollapsed', 'tabs[].filterGroups[].tags[]'];
var validate = exports.validate = function validate(values, props) {
  var errors = {};
  values.infoBar.tabs.forEach(function (tab, i) {
    if ((0, _get2["default"])(values, "tabs[".concat(i, "].tag")) === '') {
      (0, _set2["default"])(errors, "tabs[".concat(i, "].tag"), 'You must choose a tab tag.');
    }
  });
  return errors;
};
var _default = exports["default"] = function _default(props) {
  var settings = props.settings,
    icons = props.icons,
    filterGroupIcons = props.filterGroupIcons;
  var tabs = props.fields.tabs;
  var _useState = (0, _react.useState)(tabs[0].id.value),
    _useState2 = _slicedToArray(_useState, 2),
    currentTabId = _useState2[0],
    setCurrentTabId = _useState2[1];
  var onDragEnd = function onDragEnd(result) {
    var destination = result.destination,
      source = result.source;
    if (!destination) {
      return;
    }
    (0, _reorder["default"])(tabs, source.index, destination.index);
  };
  var getListStyle = function getListStyle(isDraggingOver) {
    return {
      background: isDraggingOver ? '#eee' : '#fff',
      overflow: 'auto'
    };
  };
  var getItemStyle = function getItemStyle(isDragging) {
    return {
      userSelect: 'none',
      background: isDragging ? '#f0f0f0' : ''
    };
  };
  var makeItUniqueTag = function makeItUniqueTag(_ref) {
    var _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? 'new' : _ref$prefix,
      list = _ref.list;
    if (!list.find(function (item) {
      return item.tag === prefix;
    })) {
      return prefix;
    }
    var counter = 1;
    // eslint-disable-next-line no-loop-func
    while (list.find(function (item) {
      return item.tag === "".concat(prefix).concat(counter);
    })) {
      counter++;
    }
    return "".concat(prefix).concat(counter);
  };
  var handleAddNewTab = function handleAddNewTab() {
    tabs.addField({
      id: (0, _generateNewId.generateNewId)({
        prefix: 'tab',
        settings: settings.tabs
      }),
      label: 'New tab',
      tag: makeItUniqueTag({
        prefix: 'New tab',
        list: settings.tabs
      }),
      icon: 'none',
      topFilterBar: {
        showTopFilterBar: false,
        tags: []
      },
      filterGroups: []
    });
  };
  var tabsHaveErrors = function tabsHaveErrors() {
    var error = false;
    tabs.forEach(function (tab, i) {
      var tag = (0, _get2["default"])(tabs, "[".concat(i, "].tag"));
      if (tag.error) {
        error = true;
      }
    });
    return error;
  };
  var _renderAddTabBtn = function _renderAddTabBtn() {
    if (tabs.length >= 5) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "You can't add more than 5 tabs."
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default ".concat(_style["default"].btnDisabled)
      }, "+ Add Header Tab"));
    }
    if (tabsHaveErrors()) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "One or more of your tabs have errors. Please fix them before adding more tabs."
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default ".concat(_style["default"].btnDisabled)
      }, "+ Add Header Tab"));
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default btn-xs",
      onClick: handleAddNewTab
    }, "+ Add New Tab");
  };
  var currentTab = tabs.find(function (tab) {
    return tab.id.value === currentTabId;
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable",
    direction: "horizontal"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef,
      style: getListStyle(snapshot.isDraggingOver),
      className: _style["default"].tabs
    }), settings.tabs.map(function (tab, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: tab.id,
        index: index,
        key: tab.id
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, {
          role: "presentation",
          key: 'key' + index,
          className: _style["default"].tab
        }), /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: _style["default"].dragHandle
        }, dragProvided.dragHandleProps, {
          style: getItemStyle(dragSnapshot.isDragging, dragProvided.draggableProps.style)
        }), /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            padding: '1em',
            margin: '0 auto'
          },
          className: tab.id === currentTabId ? _style["default"].activeTab : {}
        }, /*#__PURE__*/_react["default"].createElement("a", {
          onClick: function onClick() {
            return setCurrentTabId(tab.id);
          },
          style: tab.id === currentTabId ? {
            textDecoration: 'underline'
          } : {}
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: tab.label || 'Unnamed Tab'
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            paddingRight: '0.5em'
          },
          className: tab.id === currentTabId ? _style["default"].activeTab : {}
        }, tabs.length > 1 && /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
          title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
          className: "btn btn-danger btn-xs",
          isConfirm: true,
          confirmationMessage: "Are you sure you want to delete this tab: ".concat(tab.label, "?"),
          onClick: function onClick() {
            tabs.removeField(index);
            var currentTabIndex = tabs.findIndex(function (t) {
              return t.id.value === currentTabId;
            });
            if (currentTabIndex === index) {
              setCurrentTabId(tabs.find(function (t, i) {
                return i !== currentTabIndex;
              }).id.value);
            }
          }
        })));
      });
    }), provided.placeholder, _renderAddTabBtn());
  }))), /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    currentTab: currentTab,
    allTags: settings.tags,
    filterGroupIcons: filterGroupIcons,
    icons: icons,
    settings: settings
  }));
};